<script>
    /*
    	ToggleStateButton.svelte

        Not specific to expand/collapse, it now toggles any boolean state.
        Pass in paths to the SVGs - svgTruePath and svgFalsePath
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import InlineSVG from 'svelte-inline-svg'

    export let state;
    export let toggleFunction;
    export let svgTruePath;
    export let svgFalsePath;

    onMount(() => {
    })

</script>

<style>
    .toggle-state-button {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* transition: all .3s ease; */
        /* border: 1px solid red; */
    }

    :global(.toggle-state-button svg) {
        width: 100% !important;
        height: 100% !important;
        fill: var(--tcare-dull-purple) !important;
        outline: none;
    }

    /*
    :global(.toggle-state-button svg:hover) {
        fill: var(--tcare-secondary) !important;
    }
    */

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- only use one icon but rotate if expanded -->
<!--
<div class="toggle-state-button" on:click={toggleFunction} >
    <InlineSVG src={state ? svgTruePath : svgFalsePath} />
</div>
-->

<div class="toggle-state-button" on:click={toggleFunction} >
    {#if state}
        <InlineSVG src={svgTruePath} />
    {:else}
        <InlineSVG src={svgFalsePath} />
    {/if}
</div>
